import { GenericColorPicker } from "@mcleod/general";
import { Checkbox, DataHeader, DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutAuthorizationStatus extends Layout {
    checkboxIsActive: Checkbox;
    dataheaderAuthorizationStatus: DataHeader;
    layoutGenericColorPicker: GenericColorPicker;
    panelAuthorizationStatus: Panel;
    sourceAuthorizationStatus: DataSource;
    textboxDescription: Textbox;
    textboxId: Textbox;
    textboxUpdateBillingApproved: Textbox;
    textboxUpdateDetentionStatus: Textbox;
    textboxUpdatePaymentApproval: Textbox;
}
